<template>
  <div class="columns is-centered">
    <div v-show="!isSubmitted" class="b-portlet">
      <form v-on:submit.prevent="onSubmit()">
        <div class="b-portlet-header header has-text-centered">
          <h1 class="is-size-5 has-text-weight-bold">{{ $t('title.signup') }}</h1>
        </div>
        <div class="b-portlet-body">
          <b-field class="field" v-if="companyToken">
            <div class="card">
              <div class="card-content" style="padding:0.2rem !important;">
                <div class="section has-background-primary">
                  <div class="columns is-centered">
                    <div class="subtitle has-text-white">
                      <b>{{ companyName }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-field>
          <div class="field field-body">
            <b-field
              :type="{ 'is-danger': errors.has('firstName') }"
              :message="errors.first('firstName')"
            >
              <b-input
                icon-pack="fas"
                icon="user"
                :placeholder="$t('validation.attributes.firstName')"
                v-model="user.firstname"
                name="firstName"
                v-validate="'required'"
                onkeyup="this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1)"
              />
            </b-field>
            <b-field
              :type="{ 'is-danger': errors.has('lastName') }"
              :message="errors.first('lastName')"
            >
              <b-input
                icon-pack="fas"
                icon="user"
                :placeholder="$t('validation.attributes.lastName')"
                v-model="user.lastname"
                name="lastName"
                v-validate="'required'"
                onkeyup="this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1)"
              />
            </b-field>
          </div>
          <b-field
            class="field"
            :type="{ 'is-danger': errors.has('email') }"
            :message="errors.first('email')"
          >
            <b-input
              icon-pack="fas"
              icon="envelope"
              :placeholder="$t('validation.attributes.email')"
              v-model="user.email"
              name="email"
              v-validate="'required|email'"
            />
          </b-field>
          <b-field
            :type="{ 'is-danger': errors.has('password') }"
            :message="errors.first('password')"
          >
            <b-input
              type="password"
              :placeholder="
                $t('validation.attributes.password') +
                  ' (' +
                  $t('description.atLeast6Characters') +
                  ')'
              "
              icon-pack="fas"
              icon="key"
              password-reveal
              v-model="user.password"
              name="password"
              v-validate="'required|min:6'"
              ref="password"
            />
          </b-field>
          <b-field
            :type="{ 'is-danger': errors.has('confirmPassword') }"
            :message="errors.first('confirmPassword')"
          >
            <b-input
              type="password"
              :placeholder="$t('validation.attributes.confirmPassword')"
              icon-pack="fas"
              icon="key"
              password-reveal
              name="confirmPassword"
              v-model="confirmPassword"
              v-validate="'required|confirmed:password'"
            />
          </b-field>
          <b-field :type="{ 'is-danger': errors.has('city') }" :message="errors.first('city')">
            <b-select
              expanded
              icon-pack="fas"
              icon="city"
              v-model="user.cityId"
              name="city"
              :placeholder="$t('validation.attributes.city')"
              v-validate="'required'"
            >
              <option v-for="option in cities" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field
            :type="{ 'is-danger': errors.has('jobInCompany') }"
            :message="errors.first('jobInCompany')"
          >
            <b-select
              expanded
              icon-pack="fas"
              icon="briefcase"
              v-model="user.jobId"
              name="jobInCompany"
              :placeholder="$t('validation.attributes.jobInCompany')"
              v-validate="'required'"
            >
              <option v-for="option in jobs" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <div class="field field-body">
            <b-field
              :type="{ 'is-danger': errors.has('companySectorGroup') }"
              :message="errors.first('companySectorGroup')"
            >
              <b-select
                expanded
                icon-pack="fas"
                icon="building"
                name="companySectorGroup"
                :placeholder="$t('validation.attributes.companySectorGroup')"
                @input="onChangeSectorGroup"
                v-validate="'required'"
                v-model="sectorGroupId"
              >
                <option v-for="option in sectorGroups" :value="option.id" :key="option.id">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field
              :type="{ 'is-danger': errors.has('companySector') }"
              :message="errors.first('companySector')"
            >
              <b-select
                expanded
                icon-pack="fas"
                icon="building"
                v-model="user.sectorId"
                name="companySector"
                :placeholder="$t('validation.attributes.companySector')"
                v-validate="'required'"
              >
                <option v-for="option in sectors" :value="option.id" :key="option.id">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
          <b-field
            style="padding-top:10px;"
            :type="{ 'is-danger': errors.has('readAgree') }"
            :message="errors.first('readAgree')"
          >
            <b-checkbox name="readAgree" v-validate="'required:true'" v-model="user.readAgree">
              <a @click="isTermsOfServiceModalActive = true">
                {{ $t('description.readAndAgreeLink') }}
              </a>
              {{ $t('description.readAndAgree') }}.
            </b-checkbox>
          </b-field>
        </div>
        <div class="b-portlet-footer is-marginless is-paddingless">
          <div class="field is-grouped is-grouped-centered">
            <p class="control">
              <button class="button is-vcentered is-primary login-button">
                {{ $t('button.signup') }}
              </button>
            </p>
            <!-- <p class="control">
            <router-link
              class="button is-grey is-vcentered is-outlined login-button"
              :to="{ name: 'login' }"
              >{{ $t('button.cancel') }}</router-link
            >
            </p>-->
          </div>
        </div>
      </form>
    </div>
    <div v-if="isSubmitted">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('description.verifyEmailSent') }}.</h1>
        <h2 class="is-size-6">{{ $t('description.checkYourEmailInbox') }}</h2>
      </div>
    </div>
    <b-modal :active.sync="isTermsOfServiceModalActive" scroll="keep">
      <article class="message is-primary">
        <div class="message-header">
          <p>{{ $t('title.importantInformation') }}</p>
        </div>
        <div class="message-body">
          <div class="columns">
            <div class="column b-portlet" style="background-color: rgb(251, 251, 251);">
              <div class="b-portlet-body">
                <b-tabs class="block" type="is-toggle" expanded>
                  <b-tab-item label="Aydınlatma Metni" style="height:400px;">
                    <content
                      class="content"
                      style=" overflow-y: scroll; height: 400px; position: absolute;"
                    >
                      <p>
                        Bir Neta Denetim ürünü olan Online İç Denetim sayfasında kişisel verilerin
                        korunması ve güvenliği konusuna özel önem verilmektedir.
                      </p>
                      <p>
                        Bu bağlamda 6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun veya
                        KVKK”) çerçevesinde Neta Denetim ile ilişkili tüm gerçek kişilere ait her
                        türlü kişisel verinin hukuka uygun olarak işlenmesini ve muhafazasını
                        sağlamak için gerekli teknik ve idari tedbirleri almaktadır.
                      </p>

                      <p>
                        Kişisel veriler sadece aşağıda belirtilen haller çerçevesinde KVKK ve diğer
                        ilgili mevzuatlara uygun olarak işlenmektedir. KVKK kapsamında kişisel
                        verileri işlenen gerçek kişiler, aşağıdaki aydınlatma metnini inceleyerek,
                        Neta Denetim tarafından veri sorumlusu sıfatıyla toplanılan kişisel
                        verilerin neler olduğu, işlenme amaçları, aktarılabileceği kişileri,
                        toplanma yöntemi ve hukuki sebebi ile söz konusu kişisel verilere ilişkin
                        hakları hakkında bilgi edinebilir.
                      </p>
                      <br />
                      <h5>1. Hangi Kişisel Veriler Talep Edilmektedir?</h5>
                      <p>
                        KVKK bağlamında, kişisel veri, bir gerçek kişiyi belirli veya belirlenebilir
                        kılan her türlü bilgi olarak tanımlanmıştır. Online İç Denetim sitesinde
                        toplanacak veriler aşağıda belirtilmiştir:
                      </p>

                      <table class="table is-bordered is-fullwidth">
                        <thead>
                          <tr>
                            <th>Üyelik aşamasında</th>
                            <th>Süreç Soru Seti Satın Alma Aşamasında</th>
                            <th>Ödeme Aşamasında</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="width:15rem">
                              <ul>
                                <li>İsim ve soyad</li>
                                <li>E-posta adresi</li>
                                <li>Şirket ünvanı / pozisyonu</li>
                                <li>Yaşadığı şehir</li>
                                <li>Çalıştığı sektör</li>
                              </ul>
                            </td>
                            <td style="width:20rem">
                              <ul>
                                <li>Fatura bilgileri</li>
                                <li>Şahıslar: Adres ve kimlik no</li>
                                <li>
                                  Kurumlar: Ticari ünvan, adres, vergi dairesi ve vergi numarası
                                </li>
                              </ul>
                            </td>
                            <td>
                              <ul>
                                <li>
                                  Online İç Denetim tahsilat sürecini iyzico aracılığıyla bankalar
                                  üzerinden çözmekte olup herhangi bir veri talep etmemektedir.
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <br />
                      <h5>2. Kişisel Verilerin İşlenme Amaçları</h5>
                      <p>
                        Kişisel veriler KVKK ve diğer ilgili mevzuatlara uygun olarak aşağıdaki
                        amaçların gerçekleştirilmesi için sizlerden talep edilmekte ve sizlerin
                        Online İç Denetim sitesi üzerinden bizlere iletmesi şekliyle toplanmaktadır.
                        Bu veriler KVKK madde 5 ve 6 hükümlerine uygun olarak, kanunlarda açıkça
                        öngörülen hallerde, “bir hizmetin ifasıyla doğrudan doğruya ilgili olması
                        kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
                        olması halinde veya ilgili kişinin temel hak ve özgürlüklerine zarar
                        vermemek kaydıyla” işlenmektedir.
                      </p>
                      <p>
                        Kişisel verileri işleme amaçları şirket politikalarımız ve mevzuattan
                        kaynaklanan yükümlülüklerimiz doğrultusunda güncellenebilecek olup,
                        aşağıdakiler mevcut işleme amaçlarını kapsamaktadır:
                      </p>
                      <ul>
                        <li>
                          Üyelik işlemlerinin gerçekleştirilmesi, sizlere özel alanlara başka
                          kişilerin erişimlerinin engellenmesi,
                        </li>
                        <li>
                          Online İç Denetim sitesinin ürünlerini sizlere iletebilmek için kayıtların
                          ve veri tabanının güncellenmesi,
                        </li>
                        <li>
                          Platformlar üzerinden sunulan hizmetlerin iyileştirilmesi, yeni
                          hizmetlerin geliştirilmesi ve bununla ilgili bilgilendirme yapılması,
                        </li>
                        <li>
                          Neta Denetim stratejilerinin belirlenmesi ve uygulanması ve danışmanlık
                          hizmetlerinin ifası, bununla ilgili yasal adımların ve görevlerin yerine
                          getirilebilmesi (fatura basılması, sizlere iletilebilmesi gibi)
                        </li>
                        <li>
                          Bilgi güvenliği süreçlerinin planlanması, denetimi ve icrası, bilgi
                          teknolojileri alt yapısının oluşturulması ve yönetilmesi,
                        </li>
                        <li>
                          İş faaliyetlerinin ve hizmetlerin satış ve pazarlama ve/veya tanıtımı için
                          pazar araştırması faaliyetlerinin planlanması ve icrası,
                        </li>
                        <li>
                          İş ortakları ve/veya tedarikçilerin bilgiye erişim yetkilerinin
                          planlanması ve icrası, iş ortakları ve/veya tedarikçilerle olan
                          ilişkilerin yönetimi,
                        </li>
                        <li>
                          Müşteri ilişkileri yönetimi süreçlerinin planlanması ve icrası, müşteri
                          memnuniyeti süreçlerinin planlanması ve/veya takibi, müşteri talep ve/veya
                          şikayetlerinin takibi,
                        </li>
                        <li>
                          Kanunun belirlediği ve çerçevesini çizdiği hallerde yetkili kişi ve/veya
                          kuruluşlara, mevzuattan kaynaklı bilgi verilmesi,
                        </li>
                        <li>
                          İdari ve adli makamlardan gelen bilgi taleplerinin cevaplandırılması,
                        </li>
                      </ul>
                      <p>Kişisel verilerin işlenmesinde aşağıdaki ilkelere uyulmaktadır:</p>
                      <ul>
                        <li>Hukuka ve dürüstlük kurallarına uygunluk,</li>
                        <li>Doğru ve gerektiğinde güncel olma,</li>
                        <li>Verileri belirli, açık ve meşru amaçlar için işleme,</li>
                        <li>İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü olma,</li>
                        <li>
                          İlgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre
                          kadar muhafaza edilme.
                        </li>
                      </ul>
                      <br />
                      <h5>3. Kişisel Verilerin Aktarılması</h5>

                      <p>
                        Neta Denetim, kişisel verilerin aktarılması konusunda KVKK’da öngörülen ve
                        Kişisel Verileri Koruma Kurulu tarafından alınan karar ve ilgili
                        düzenlemelere uygun bir şekilde hareket etmek sorumluluğu altındadır.
                      </p>

                      <p>
                        Neta Denetim tarafından ilgililere ait kişisel veriler ilgili kişinin açık
                        rızası olmadan başka gerçek kişilere veya tüzel kişilere aktarılamaz. Şu
                        kadar ki, KVKK ve diğer Kanunların zorunlu kıldığı durumlarda ilgilinin açık
                        rızası olmadan da veriler mevzuatta öngörülen şekilde ve sınırlarla bağlı
                        olarak yetkili kılınan idari veya adli kurum veya kuruluşa aktarılabilir.
                      </p>
                      <br />
                      <h5>4. Kişilerin Hakları ve Hakların Kullanımı</h5>

                      <p>
                        İlgili kişilerin kişisel verileri üzerinde hakları mevcuttur ve Neta Denetim
                        veri sorumlusu olduğu durumlarda bu hakların korunması ve gerekli şartların
                        yerine getirilmesinden sorumludur.
                      </p>

                      <p>
                        Aşağıda belirtilen hakların kullanımı ile ilgili talepler
                        www.netadenetim.com adresinde bulunan Başvuru Formu aracılığı ile yazılı
                        olarak veya elektronik ortamda info@netadenetim.com adresine veya 5070
                        sayılı Elektronik İmza Kanununda tanımlı olan güvenli elektronik imzalı
                        olarak ‘‘Kişisel Veri Bilgi Edinme Talebi’’ ifadesi ile iletilmesi
                        gerekmektedir.
                      </p>
                      <p>
                        Kanunun 11. maddesi çerçevesinde ilgili kişi her zaman veri sorumlusuna
                        başvurarak kendisi ile ilgili;
                      </p>
                      <p></p>
                      <ul>
                        <li>Kişisel verilerinin işlenip işlenmediğini öğrenme,</li>
                        <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                        <li>
                          Kişisel verilerinin işlenme amacını ve bunların amacına uygun kullanılıp
                          kullanılmadığını öğrenme,
                        </li>
                        <li>
                          Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü
                          kişileri bilme,
                        </li>
                        <li>
                          Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların
                          düzeltilmesini isteme,
                        </li>
                        <li>Kişisel verilerin silinmesini veya yok edilmesini isteme,</li>
                        <li>
                          Kişisel verilerin düzeltilmesi, silinmesi veya yok edilmesine ilişkin
                          işlemlerin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini
                          isteme,
                        </li>
                        <li>
                          İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz
                          edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına
                          itiraz etme,
                        </li>
                        <li>
                          İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz
                          edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına
                          itiraz etme,
                        </li>
                        <li>
                          İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz
                          edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına
                          itiraz etme,
                        </li>
                        <li>
                          Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması
                          hâlinde zararın giderilmesini talep etme, haklarına sahiptir.
                        </li>
                      </ul>
                      <br />
                      <h5>5. Kişisel Verilerin Güvenliği</h5>
                      <p>
                        Neta Denetim, kişisel verilere yetkisiz erişimi, hatalı kullanımı, kişisel
                        verilerin hukuka aykırı olarak işlenmesini, ifşa edilmesini,
                        değiştirilmesini veya imha edilmesini engellemek için gerekli önlemleri
                        almaktadır.
                      </p>
                      <p>
                        Online İç Denetim sitesi dahilinde kişisel verileri işlerken güvenlik
                        duvarları ve Güvenli Soket Katmanı (SSL) şifrelemesi gibi genel kabul görmüş
                        güvenlik teknolojisi standartlarını kullanmaktadır.
                      </p>
                      <p>
                        Ayrıca Online İç Denetim sayfasında çerez (cookie) toplanmamaktadır.
                        Gerektiği durumlarda, uçtan-uca güvenlik sağlamak için, güvenlik belirteci
                        (Security Token) kullanılmaktadır. Böylece bağlantılar arasında güvenli ağ
                        örüldüğünden emin olunmaktadır.
                      </p>
                      <br />
                      <h5>6. Gizlilik Taahhüdümüz</h5>
                      <p>
                        Neta Denetim olarak yerel ve küresel kanunlar ile uyumlu çalışma
                        prensibimize bağlı kalacağımızı, burada açıkladığımız kriterler dahilinde
                        bilgilerinizi koruyup, sahip çıkacağımızı sizlere taahhüt ederiz.
                      </p>
                      <p>
                        Bu taahhüdümüze paralel olarak kişisel bilgileriniz hiçbir şekilde üçüncü
                        şahıslar ve kurumlar ile paylaşılmayacaktır.
                      </p>
                    </content>
                  </b-tab-item>
                  <b-tab-item label="Site Kullanım Şartları" style="height:400px;">
                    <content
                      class="content"
                      style=" overflow-y: scroll; height: 400px; position: absolute;"
                    >
                      <content class="content">
                        <p>
                          <strong>
                            KULLANICILAR, WEBSİTE’SİNİ VE WEBSİTE’SİNDE VERİLEN HİZMETLERİ
                            KULLANMAYA BAŞLAYARAK VE/VEYA WEBSİTE’SİNE ÜYE OLARAK İŞBU KULLANIM
                            ŞARTLARINI VE GİZLİLİK POLİTİKASINI OKUDUKLARINI, ANLADIKLARINI VE
                            BUNLARLA BAĞLI OLDUKLARINI KABUL ETMİŞ OLURLAR. KULLANIM ŞARTLARI
                            ARASINDA KABUL ETMEDİĞİNİZ MADDELER OLMASI HALİNDE SİTE’Yİ KULLANMAYI
                            DERHAL SONLANDIRMALISINIZ.
                          </strong>
                        </p>
                        <p>
                          <strong>WEBSİTESİ ÜYELİK SÖZLEŞMESİ ve SİTE KULLANIM ŞARTLARI</strong>
                        </p>
                        <ol>
                          <li>
                            <strong>TARAFLAR</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>1.1.</strong> İşbu üyelik sözleşmesi ("Üyelik Sözleşmesi/
                          Sözleşme") merkezi Ağaoğlu My Office Çiğdem Sokak No:1 D:18 34746
                          Ataşehir/ İstanbul adresinde bulunan Neta Dijital Hizmetler Denetim
                          Danışmanlık Ve Dış Ticaret Limited Şirketi (“NETA DENETİM”) ile NETA
                          DENETİM’in sahibi olduğu
                          <a href="http://www.onlineicdenetim.com">www.onlineicdenetim.com</a> (
                          “İnternet Sitesi”) internet sitesine üye olan/olacak (bundan böyle kısaca
                          “Üye” olarak anılacaktır) kişi arasında, (ayrı ayrı Taraf birlikte
                          Taraflar) Tarafların hak ve yükümlülüklerinin, İnternet Sitesi üzerinde
                          sunulan hizmetlerin, uygulamaların ve içeriklerin kullanılması
                          koşullarının belirlenmesi amacıyla oluşturulmuştur.
                        </p>
                        <ol start="2">
                          <li>
                            <strong>TANIMLAR</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>Hizmet/ler:</strong> Üye’nin işbu Üyelik Sözleşmesi içerisinde
                          tanımlı olan iş ve işlemlerini gerçekleştirmelerini sağlamak amacıyla NETA
                          DENETİM tarafından sunulan hizmet ve uygulamaları ifade eder.
                        </p>
                        <p>
                          <strong>Websitesi:</strong> Mülkiyeti NETA DENETİM’e ait olan ve NETA
                          DENETİM’in işbu Sözleşme ile belirlenen Hizmetler’i üzerinde sunmakta
                          olduğu www.onlineicdenetim.com alan adına sahip internet sitesini, mobil
                          uygulamalarını ve mobil siteyi ifade eder.
                        </p>
                        <p>
                          <strong>Ziyaretçi</strong> / <strong>Kullanıcı:</strong> Websitesi’ni Üye
                          olmadan kullanan ve Hizmetler’den faydalanan gerçek kişiyi ifade eder.
                        </p>
                        <p>
                          <strong>Üye:</strong>Websitesi’nin ilgili bölümünden “Üye” olmak isteyen
                          gerçek veya tüzelkişi Ziyaretçi tarafından üye olmak için gerekli olan
                          üyelik formunun doldurulması, kimlik bilgilerinin verilmesi, kimlik
                          bilgilerinin doğruluğunun onaylanması suretiyle kayıt işleminin
                          yaptırılması ve NETA DENETİM tarafından kayıt işleminin onaylanması ile
                          tamamlanır.
                        </p>
                        <p>
                          <strong>Gizlilik ve Kişisel Verilerin Korunması Politikası:</strong>
                          Üye’'nin Websitesi üzerinden ilettikleri kişisel verilerin, NETA DENETİM
                          tarafından hangi amaçlarla ve ne şekilde kullanılacağı gibi konular da
                          dahil olmak üzere NETA DENETİM'in kişisel verilere ilişkin genel gizlilik
                          politikasını düzenleyen ve Websitesi üzerinden erişilebilecek olan metni
                          ifade eder.
                        </p>
                        <p>
                          <strong>Link:</strong> Websitesi üzerinden bir başka web sitesine,
                          dosyalara, içeriğe veya başka bir web sitesinden bu Websitesi’ne,
                          dosyalara ve içeriğe erişimi mümkün kılan bağlantıdır.
                        </p>
                        <p>
                          <strong>İçerik</strong>: Websitesi'nde ve/veya herhangi bir web sitesinde
                          yayınlanan veya erişimi mümkün olan her türlü bilgi, dosya, resim,
                          program, rakam, fiyat, vs. görsel, yazınsal ve işitsel imgelerdir.
                        </p>
                        <p>
                          <strong>Websitesi Üyelik ve Kullanım Koşulları Sözleşmesi</strong>:
                          Websitesi vasıtasıyla sunulmakta olan ticari ve kişiye özel nitelikteki
                          hizmetlerden yararlanacak gerçek ve/veya tüzel kişilerle NETA DENETİM
                          arasında elektronik ortamda akdedilen işbu sözleşmedir.
                        </p>
                        <ol start="3">
                          <li>
                            <strong>ÜYELİK SÖZLEŞMESİ'NİN KAPSAM VE AMACI</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>3.1.</strong> Üyelik Sözleşmesi uyarınca Üye, Websitesi’ne üye
                          olmak, Hizmetler’den faydalanmak ve bu platformda satılan hizmetleri satın
                          almak istemektedir.
                        </p>
                        <p>
                          <strong>3.2.</strong> Üyelik Sözleşmesi’nin amacını, Hizmetler’den
                          yararlanmasına ilişkin koşulların belirlenmesi ve bu doğrultuda
                          Taraflar'ın hak ve yükümlülüklerinin tespiti oluşturmaktadır.
                        </p>
                        <p>
                          <strong>3.3.</strong> Üyelik Sözleşmesi'nin Üye tarafından kabulü ile Üye,
                          Websitesi'nde yer alan ve yer alacak olan Hizmetler'e, kullanıma,
                          içeriklere, uygulamalara ve Üyeler'e yönelik her türlü beyanı da kabul
                          etmiş olduğunu beyan ve taahhüt eder.
                        </p>
                        <ol start="4">
                          <li>
                            <strong>TARAFLAR'IN HAK VE YÜKÜMLÜLÜKLERİ</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>4.1.</strong> Üyelik statüsünün kazanılması için, Üyelik
                          Sözleşmesi'nin onaylanması ve üyelik sayfasında talep edilen bilgilerin
                          doğru ve güncel bilgilerle doldurması gerekmektedir. Üye olmak isteyen
                          kullanıcının 18 (on sekiz) yaşını doldurmuş olması gerekmektedir. Üyelik
                          Sözleşmesi’ni doldururken doğru ve güncel bilgi sağlamayan Üye, bu sebeple
                          doğabilecek tüm zararlardan bizzat sorumludur.
                        </p>
                        <p>
                          <strong>4.2.</strong> Üyelik hak ve yükümlülüklerinin hangi kişiye ait
                          olduğu konusunda ihtilaf olması ve bu hususta söz konusu kişilerin NETA
                          DENETİM'den talepte bulunması halinde NETA DENETİM, ilgili Üyelik hesabı
                          kullanılarak herhangi bir Hizmet için NETA DENETİM'e ödeme yapan en son
                          kişinin Üyelik hesabının sahibi olduğunu kabul ederek, bu doğrultuda işlem
                          yapma hakkına sahiptir.
                        </p>
                        <p>
                          <strong>4.3.</strong> Üye, Websitesi üzerinde gerçekleştirdiği işlemlerde
                          ve yazışmalarda, işbu Üyelik Sözleşmesi'nin hükümlerine, Websitesi'nde
                          belirtilen tüm koşullara, yürürlükteki mevzuata ve ahlak kurallarına uygun
                          olarak hareket edeceğini kabul ve beyan eder. Üye'nin Websitesi dâhilinde
                          yaptığı işlem ve eylemlere ilişkin hukuki ve cezai sorumluluk kendisine
                          aittir.
                        </p>
                        <p>
                          <strong>4.4.</strong> Üye verilerinin NETA DENETİM’in ihmali görülmeden
                          yetkisiz kişilerce okunmasından (üyenin bilgilerini başka kişiler ile
                          paylaşması, siteden ayrılırken çıkış yapmaması, ve benzeri durumlardan
                          kaynaklı olarak) dolayı gelebilecek zararlardan ötürü NETA DENETİM sorumlu
                          değildir.
                        </p>
                        <p>
                          <strong>4.5.</strong> Kullanıcı, NETA DENETİM hizmetlerini kullanarak elde
                          edilen herhangi bir kayıt veya elde edilmiş bilgilerin tamamiyle kendi
                          rızası dahilinde olduğunu, bilgisayarında yaratacağı arızalar, bilgi kaybı
                          ve diğer kayıpların sorumluluğunun tamamiyle kendisine ait olduğunu,
                          servisin kullanımından dolayı uğrayabileceği zararlardan dolayı NETA
                          DENETİM’den tazminat talep etmeyeceğini kabul eder.
                        </p>
                        <p>
                          <strong>4.6</strong>. Kullanıcı, NETA DENETİM’in dilediği zaman veya
                          sürekli olarak tüm sistemi izleyebileceğini, kurallara aykırı davrandığı
                          takdirde gerekli müdahalelerde bulunma, Üye’yi servis dışına çıkarma ve
                          üyeliğe son verme hakkına sahip olduğunu kabul ve beyan eder
                        </p>
                        <p>
                          <strong>4.7.</strong> Üye'nin kendi sayfası'na erişmek ve Websitesi
                          üzerinden işlem gerçekleştirebilmek için ihtiyaç duyduğu kullanıcı adı ve
                          şifre bilgisi, Üye tarafından oluşturulmakta olup, söz konusu bilgilerin
                          güvenliği ve gizliliği tamamen Üye'nin sorumluluğundadır. Üye, kendisine
                          ait kullanıcı adı ve şifre ile gerçekleştirilen işlemlerin kendisi
                          tarafından gerçekleştirilmiş olduğunu, bu işlemlerden kaynaklanan
                          sorumluluğunun peşinen kendisine ait olduğunu, bu şekilde gerçekleştirilen
                          iş ve işlemleri kendisinin gerçekleştirmediği yolunda herhangi bir def'i
                          ve/veya itiraz ileri süremeyeceğini ve/veya bu def'i veya itiraza
                          dayanarak yükümlülüklerini yerine getirmekten kaçınmayacağını; Üyeliğini
                          tek taraflı olarak iptal ettirse bile, bu iptal işleminden önce, üyeliği
                          sırasında gerçekleştirdiği tüm icraatlardan birebir sorumlu olacağını,
                          kabul, beyan ve taahhüt eder.
                        </p>
                        <p>
                          <strong>4.8.</strong>Hizmet’in tesliminden sonra Üye’ye ait kredi kartının
                          Üye’nin kusurundan kaynaklanmayan bir şekilde yetkisiz kişilerce haksız
                          veya hukuka aykırı olarak kullanılması nedeni ile ilgili banka veya finans
                          kuruluşunun ürün bedelini NETA DENETİM’e ödememesi halinde Üye, hizmet
                          bedelini (3) gün içerisinde ödemekle yükümlüdür.
                        </p>
                        <p>
                          <strong>4.9.</strong> NETA DENETİM, Hizmet’i alan kişi ile sipariş
                          esnasında kullanılan kredi kartı hamilinin aynı kişi olmaması veya
                          Hizmet’in Üye’ye tesliminden evvel, siparişte kullanılan kredi kartına
                          ilişkin güvenlik açığı tespit edilmesi halinde, NETA DENETİM, kredi kartı
                          hamiline ilişkin kimlik ve iletişim bilgilerini, siparişte kullanılan
                          kredi kartının bir önceki aya ait ekstresini yahut kart hamilinin
                          bankasından kredi kartının kendisine ait olduğuna ilişkin yazıyı ibraz
                          etmesini Üye’den talep edebilir ve temine kadar geçen süre için sipariş
                          dondurulabilir ve mezkur taleplerin 24 saat içerisinde karşılanmaması
                          halinde ise, siparişi iptal etme hakkını haizdir.
                        </p>
                        <p>
                          <strong>4.10.</strong> Üye, Websitesi'ni aşağıda sayılan haller başta
                          olmak üzere hukuka ve ahlaka aykırı bir şekilde kullanmayacaktır:
                        </p>
                        <ul>
                          <li>
                            Websitesi'nin herhangi bir kişi adına veri tabanı, kayıt veya rehber
                            yaratmak, amacıyla kullanılması;
                          </li>
                          <li>
                            Websitesi'nin bütününün veya bir bölümünün bozma, değiştirme veya ters
                            mühendislik yapma amacıyla kullanılması;
                          </li>
                          <li>
                            Yanlış bilgiler veya başka bir kişinin bilgileri kullanılarak işlem
                            yapılması, yanlış veya yanıltıcı ikametgâh adresi, elektronik posta
                            adresi, iletişim, ödeme veya hesap bilgileri de dahil yanlış veya
                            yanıltıcı kişisel veriler kullanmak suretiyle gerçek olmayan Üyelik
                            hesapları oluşturulması ve bu hesapların Üyelik Sözleşmesi'ne veya
                            yürürlükte mevzuata aykırı şekilde kullanılması, başka bir Üye'nin
                            hesabının izinsiz kullanılması, başka birinin yerine geçilerek ya da
                            yanlış bir isimle işlemlere taraf ya da katılımcı olunması;
                          </li>
                          <li>
                            Virüs veya Websitesi'ne, Websitesi'nin veri tabanına, Websitesi üzerinde
                            yer alan herhangi bir içeriğe zarar verici herhangi başka bir teknoloji
                            yayılması;
                          </li>
                          <li>
                            Üyeler hakkında elektronik posta adresleri de dâhil herhangi bir
                            bilginin ilgili kişilerin izni olmaksızın toplanması veya 6698 sayılı
                            Kişisel Verilerin Korunması Hakkında Kanun uyarınca ihlal teşkil edecek
                            diğer uygulamalarda bulunulması;
                          </li>
                          <li>
                            Websitesi tarafından belirlenmiş olan iletişimler ve teknik sistemler
                            üzerinde makul olmayan veya orantısız derecede büyük yüklemeler
                            yaratacak ya da teknik işleyişe zarar verecek faaliyetlerde bulunulması,
                            NETA DENETİM'in önceden yazılı iznini alınmaksızın Websitesi üzerinde
                            otomatik program, robot, web crawler, örümcek, veri madenciliği (data
                            mining) ve veri taraması (data crawling) gibi "screen scraping"
                            yazılımları veya sistemleri kullanılması ve bu şekilde Websitesi'nde yer
                            alan herhangi bir içeriğin tamamının veya bir kısmının izinsiz
                            kopyalanarak, yayınlanması veya kullanılması;
                          </li>
                          <li>
                            NETA DENETİM’in izni olmaksızın NETA DENETİM hizmetlerinin ticari ya da
                            reklam amacıyla kullanılması,
                          </li>
                        </ul>
                        <p>
                          <strong>4.11.</strong> Üye, Websitesi’nde yaptığı işlemleri Websitesi’ne
                          teknik olarak hiçbir surette zarar vermeyecek şekilde yürütmekle
                          yükümlüdür. Üye, Websitesi’ne sağlayacağı tüm bilgi, içerik, materyal ve
                          sair içeriğin sisteme zarar verecek her türlü program, virüs, yazılım,
                          lisansız ürün, truva atı vb. içermemesi için gerekli koruyucu yazılımları
                          ve lisanslı ürünleri kullanmak da dâhil olmak üzere gerekli her türlü
                          tedbiri aldığını kabul ve taahhüt eder. Üye ayrıca kendi sayfası'na robot
                          veya otomatik giriş yöntemleriyle girmeyeceğini kabul eder.
                        </p>
                        <p>
                          <strong>4.12</strong>. NETA DENETİM, Websitesi’nin herhangi bir zamanda,
                          sistemin çalışmasını geçici bir süre askıya alabilir veya tamamen
                          durdurabilir. Sistemin geçici bir süre askıya alınması veya tamamen
                          durdurulmasından dolayı Üyelerine veya üçüncü şahıslara karşı hiçbir
                          sorumluluğu olmayacaktır.
                        </p>
                        <p>
                          <strong>4.13.</strong> NETA DENETİM, Webitesi hizmetlerinde meydana
                          gelecek teknik arızalar nedeniyle Üye’nin uğrayacağı zarardan sorumlu
                          değildir. NETA DENETİM, servislerinin her zaman ve her şart altında
                          zamanında, güvenli ve hatasız olarak sunulacağını, servis kullanımından
                          elde edilen sonuçların her zaman doğru ve güvenilir olacağını, servis
                          kalitesinin herkesin beklentilerine cevap vereceğini taahhüt etmez. NETA
                          DENETİM, kendi sitesi üstünden yapılan ve zarar doğurabilecek her türlü
                          haberleşmeyi, yayını, bilgi aktarımını istediği zaman kesme hakkını ve
                          gereken koşullar oluştuğu takdirde Üye mesajlarını silme, Üye’yi
                          servislerden menetme ve üyeliğine son verme hakkını saklı tutar.
                        </p>
                        <p>
                          <strong>4.14.</strong> Websitesi’nde kendisinin veya üçüncü kişilerin
                          hizmetleri hakkında reklam ve promosyonlar görüntülenebilir. Bu reklam ve
                          promosyonların içerikleri hakkındaki sorumluluklar, reklam veya promosyon
                          sahiplerindedir; NETA DENETİM bu reklam ve promosyonlarla ilgili olarak
                          sorumluluk kabul etmez.
                        </p>
                        <p>
                          <strong>4.15.</strong> Websitesi’nde, NETA DENETİM’in kontrolü altında
                          olmayan başka internet sitelerine bağlantı veya referans bulunabilir. NETA
                          DENETİM, bu sitelerin içerikleri veya içerdikleri diğer bağlantılardan
                          sorumlu değildir
                        </p>
                        <ol start="5">
                          <li>
                            <strong>GİZLİLİK ve KİŞİSEL VERİLERİN KORUNMASI</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>5.1.</strong> NETA DENETİM, Üye'nin Websitesi'nde sunulan
                          Hizmetler'den yararlanabilmek için Websitesi üzerinden kendisine sağladığı
                          kişisel verilerin 6698 sayılı Kişisel Verilerin Korunması Kanunu da dahil
                          her türlü mevzuata uygun bir şekilde işlenmesine, güvenliğinin
                          sağlanmasına ve korunmasına önem vermektedir. NETA DENETİM, bu kapsamda
                          Üye'nin sağladığı kişisel verileri Websitesi'nde yer alan Gizlilik ve
                          Kişisel Verilerin Korunması Politikası'na uygun olarak toplamakta,
                          kullanmakta, aktarmakta ve diğer şekillerde işleyebilmektedir.
                        </p>
                        <p>
                          Üye, kişisel verilerinin kullanılması ile ilgili koşullar ve bu konudaki
                          haklarıyla ilgili olarak daha fazla bilgi edinmek için Websitesi'nde yer
                          alan Gizlilik ve Kişisel Verilerin Korunması Politikası'nı her zaman
                          inceleyebileceğini ve burada belirtilen şekilde info@netadenetim.com
                          adresine elektronik posta göndererek ya da Websitesi’nde yer alan Başvuru
                          Formu’nda belirtilen diğer yöntemlerle kullanabileceğini anlamaktadır.
                        </p>
                        <p>
                          <strong>5.2.</strong> Üye tarafından Websitesi'nde Üyelik oluşturmak veya
                          Websitesi’nden faydalanmak amacıyla paylaşılan kişisel veriler; Üyelik
                          Sözleşmesi ile belirlenen yükümlülüklerin ifası, Websitesi'nin işletilmesi
                          için gereken uygulamaların yürütülmesi, Üye veya Ziyaretçi’ye çeşitli
                          avantajların sağlanıp sunulabilmesi, ödeme işlemlerinin
                          gerçekleştirilmesi, sipariş teslimatlarının yapılması, müşteri hizmetleri
                          ve şikayet takibi işlemlerinin gerçekleştirilmesi ve Üye’ye özel reklam,
                          satış, pazarlama, anket, benzer amaçlı her türlü elektronik iletişim,
                          profilleme, istatistiksel çalışmalar yapılması amacıyla NETA DENETİM ya da
                          iş ortakları tarafından Gizlilik ve Kişisel Verilerin Korunması
                          Politikası'na uygun olarak toplanmakta, saklanmakta ve işlenmektedir.
                        </p>
                        <p>
                          Üye’nin NETA DENETİM ile paylaşmış olduğu kişisel bilgiler bu amaç dışında
                          kullanılmaz ve 3. Şahıslar ile paylaşılmaz.
                        </p>
                        <p>
                          <strong>5.3.</strong> NETA DENETİM, yürürlükteki mevzuat uyarınca yetkili
                          makamların talebi halinde, Üye'nin kendisinde bulunan bilgilerini 6698
                          sayılı Kişisel Verilerin Korunması Kanunu uyarınca gerekli olduğu takdirde
                          Üye'yi önceden bilgilendirmek suretiyle ve her durumda veri aktarım
                          kurallarına tabi olarak söz konusu makamlarla paylaşabilecektir.
                        </p>
                        <p>
                          <strong>5.4.</strong> Websitesi’ne üyelik sırasında ve/veya hizmet
                          alışverişi sırasında Üyeler'den alınan kişisel veriler, Websitesi’nin
                          kötüye kullanımı, 6102 sayılı Türk Ticaret Kanunu anlamında suç
                          oluşturabilecek konularda çıkan uyuşmazlıklarda, yalnızca talep edilen
                          konu ile sınırlı olmak üzere tarafların yasal haklarını kullanabilmeleri
                          amacıyla, 6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca gerekli
                          olduğu takdirde ilgili kişi önceden bilgilendirilmek suretiyle ve her
                          durumda veri aktarım kurallarına tabi olarak uyuşmazlığa taraf olabilecek
                          diğer Üye’lere iletebilecektir.
                        </p>
                        <ol start="6">
                          <li>
                            <strong>FİKRİ MÜLKİYET HAKLARI</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>6.1.</strong> onlineicdenetim.com markası, logosu ve Websitesi'nin
                          tasarımı, yazılımı, alan adı ve bunlara ilişkin olarak NETA DENETİM
                          tarafından oluşturulan her türlü marka, tasarım, logo, ticari takdim
                          şekli, slogan ve diğer tüm içeriğin her türlü fikri mülkiyet hakkı ile
                          NETA DENETİM'in mülkiyetindedir. Üye, NETA DENETİM'in veya bağlı
                          şirketlerinin mülkiyetine tabi fikri mülkiyet haklarını NETA DENETİM'in
                          izni olmaksızın kullanamaz, paylaşamaz, dağıtamaz, sergileyemez,
                          çoğaltamaz veya bunlardan türemiş çalışmalar yapamaz. Üye,
                          onlineicdenetim.com Websitesi'nin bütünü ya da bir kısmını başka bir
                          ortamda NETA DENETİM'in izni olmaksızın kullanamaz. Üye'nin, üçüncü
                          kişilerin veya NETA DENETİM'in fikri mülkiyet haklarını ihlal edecek
                          şekilde davranması halinde, Üye, NETA DENETİM’in ve/veya söz konusu üçüncü
                          kişinin tüm doğrudan ve dolaylı zararları ile masraflarını tazmin etmekle
                          yükümlüdür.
                        </p>
                        <p>
                          <strong>6.2.</strong> NETA DENETİM, Websitesi Üyeler’inin ürettiği ve
                          yayınlanmak üzere kendi iradesiyle sisteme yüklediği (örneğin İnternet
                          Sitesi'ne eklediği mesaj, haber, dosya, sunum, video web sayfası gibi)
                          bilgi, belge, yazılım, tasarım, grafik, resim vb. tüm eserleri tanıtım,
                          duyurum amacı ile yayınlama ve/veya site içerisinde uygun görülecek başka
                          bir adrese taşıma haklarına sahiptir. Yayınlanan bu bilgilerin başka
                          kullanıcılar tarafından kopyalanması ve/veya yayınlanması ihtimal
                          dahilindedir. Bu hallerde Üye, NETA DENETİM’den telif ve benzeri hiçbir
                          ücret talep etmeyecektir.
                        </p>
                        <p>
                          <strong>6.3.</strong> Üyeler başkalarına ait fikri ve sınai mülkiyet
                          haklarının korunması için gerekli özeni göstermekle yükümlüdür. Üyeler
                          sadece telif hakları kendisine ait olan içeriği sisteme yükleyebilir. Eğer
                          Üye, fikri ve sınai mülkiyet hakları başkasına ait olan yazı, fotoğraf,
                          resim, logo, video ve sair içeriği, söz konusu eser ve hak sahiplerinin
                          izni olmaksızın sisteme yüklerse, NETA DENETİM, ihlale konu olan İçeriği
                          derhal yayından kaldırmak ve gerektiğinde bu ihlali gerçekleştiren
                          üyelerin üyeliğine son vermek haklarına sahiptir. Üçüncü şahısların fikri
                          ve sınai mülkiyet haklarını ihlal eden üyeler, bu ihlallerden ve bu
                          ihlallerden doğan her türlü zarardan üçüncü şahıslar ile kamu kurum ve
                          kuruluşlarına karşı hukuki ve cezai olarak bizzat sorumludurlar.
                        </p>
                        <ol start="7">
                          <li>
                            <strong>SÖZLEŞME'NİN SONA ERMESİ</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>7.1.</strong> Sözleşme süresizdir. Taraflar'dan herhangi biri,
                          işbu Üyelik Sözleşmesi'ni tek taraflı olarak ve tazminat ödemeksizin her
                          zaman feshedilebilir. Böyle bir fesih halinde Taraflar fesih tarihine
                          kadar doğmuş olan hak ve borçları karşılıklı olarak tamamen ifa
                          edeceklerdir.
                        </p>
                        <p>
                          <strong>7.2.</strong> NETA DENETİM, Üye’nin işbu Üyelik Sözleşmesi'nin
                          herhangi bir maddesini ihlal ettiğini tespit etmesi veya buna ilişkin
                          makul bir şüphe duyması halinde üyeliği askıya alma, sonlandırma, dava ve
                          takip haklarına sahiptir.
                        </p>
                        <ol start="8">
                          <li>
                            <strong>MÜCBİR SEBEP</strong>
                          </li>
                        </ol>
                        <p>
                          Ayaklanma, ambargo, devlet müdahalesi, isyan, işgal, savaş, seferberlik,
                          grev, lokavt, iş eylemleri veya boykotlar dahil olmak üzere işçi-işveren
                          anlaşmazlıkları, siber saldırı, iletişim sorunları, altyapı ve internet
                          arızaları, sisteme ilişkin iyileştirme veya yenileştirme çalışmaları ve bu
                          sebeple meydana gelebilecek arızalar, elektrik kesintisi, yangın, patlama,
                          fırtına, sel, deprem, göç, salgın veya diğer bir doğal felaket veya NETA
                          DENETİM'in kontrolü dışında gerçekleşen, kusurundan kaynaklanmayan ve
                          makul olarak öngörülemeyecek diğer olaylar ("Mücbir Sebep") NETA
                          DENETİM'in işbu Üyelik Sözleşmesi'nden doğan yükümlülüklerini ifa etmesini
                          engeller veya geciktirirse, NETA DENETİM ifası Mücbir Sebep sonucunda
                          engellenen veya geciken yükümlülüklerinden dolayı sorumlu tutulamaz ve bu
                          durum işbu Üyelik Sözleşmesi’nin bir ihlali olarak kabul edilemez.
                        </p>
                        <ol start="9">
                          <li>
                            <strong>ÇEŞİTLİ HÜKÜMLER</strong>
                          </li>
                        </ol>
                        <p>
                          <strong>9.1. Garanti Vermeme:</strong>işbu Sözleşme maddesi uygulanabilir
                          kanunun izin verdiği azami ölçüde geçerli olacaktir. NETA DENETİM
                          tarafindan sunulan hizmetler "olduğu gibi” ve "mümkün olduğu” temelde
                          sunulmakta ve pazarlanabilirlik, belirli bir amaca uygunluk veya ihlal
                          etmeme konusunda tüm zimni garantiler de dâhil olmak üzere hizmetler veya
                          uygulama ile ilgili olarak (bunlarda yer alan tüm bilgiler dâhil) sarih
                          veya zimni, kanuni veya başka bir nitelikte hiçbir garantide
                          bulunmamaktadir.
                        </p>
                        <p>
                          <strong>9.2 Sözleşme Değişiklikleri:</strong> NETA DENETİM, tamamen kendi
                          takdirine bağlı olmak üzere, işbu Üyelik Sözleşmesi'ni ve Websitesi'nde
                          yer alan Gizlilik ve Kişisel Verilerin Korunması Politikası da dahil her
                          türlü politikayı, hüküm ve şartı uygun göreceği herhangi bir zamanda,
                          yürürlükteki mevzuat hükümlerine aykırı olmamak kaydıyla Websitesi'nde
                          ilan ederek tek taraflı olarak değiştirebilir. İşbu Üyelik Sözleşmesi'nin
                          değişen hükümleri, Websitesi'nde ilan edildikleri tarihte geçerlilik
                          kazanacak, geri kalan hükümler aynen yürürlükte kalarak hüküm ve
                          sonuçlarını doğurmaya devam edecektir. Şüpheye mahal vermemek adına, işbu
                          Üyelik Sözleşmesi Üye tarafından tek taraflı olarak değiştirilemez.
                        </p>
                        <p>
                          <strong>9.3. Üyelik Sözleşmesi'nin Devri.</strong> Üye, NETA DENETİM'in
                          önceden yazılı onayını almaksızın işbu Üyelik Sözleşmesi’ndeki haklarını
                          veya yükümlülüklerini tümüyle veya kısmen temlik edemeyecektir.
                        </p>
                        <p>
                          <strong>9.4. Feragat.</strong> Taraflar'dan birinin Üyelik Sözleşmesi'nde
                          kendisine verilen herhangi bir hakkı kullanmaması ya da icra etmemesi, söz
                          konusu haktan feragat ettiği anlamına gelmeyecek veya söz konusu hakkın
                          daha sonra kullanılmasını ya da icra edilmesini engellemeyecektir.
                        </p>
                        <p>
                          <strong>9.5. Delil Sözleşmesi.</strong> Üye, işbu Üyelik Sözleşmesi’nden
                          doğabilecek ihtilaflarda NETA DENETİM'in resmi defter ve ticari kayıtları
                          ile NETA DENETİM'in veri tabanında, sunucularında tutulan e-arşiv
                          kayıtlarının, elektronik bilgilerin, elektronik yazışmaların ve bilgisayar
                          kayıtlarının, bağlayıcı, kesin ve münhasır delil teşkil edeceğini ve bu
                          maddenin 6100 sayılı Hukuk Muhakemeleri Kanunu uyarınca delil sözleşmesi
                          niteliğinde olduğunu kabul eder.
                        </p>
                        <p>
                          <strong>9.6. Üyelik Sözleşmesi'nin Bütünlüğü ve Bölünebilirliği.</strong>
                          İşbu Üyelik Sözleşmesi, konuya ilişkin olarak Taraflar arasındaki
                          anlaşmanın tamamını oluşturmaktadır. İşbu Üyelik Sözleşmesi’nin herhangi
                          bir hükmünün yetkili herhangi bir mahkeme, tahkim heyeti veya idari makam
                          tarafından tümüyle veya kısmen geçersiz veya uygulanamaz olduğu veya makul
                          olmadığına karar verilmesi halinde, söz konusu geçersizlik, uygulanamazlık
                          veya makul olmama ölçüsünde işbu Üyelik Sözleşmesi bölünebilir olarak
                          kabul edilecek ve diğer hükümler tümüyle yürürlükte kalmaya devam
                          edecektir.
                        </p>
                        <p>
                          <strong>9.7. Bildirim.</strong> NETA DENETİM, Üye ile Üye'nin kayıt
                          olurken bildirmiş olduğu elektronik posta adresi vasıtasıyla veya telefon
                          numarasına arama yapmak ve SMS göndermek suretiyle iletişim kuracaktır.
                          Üye, elektronik posta adresini ve telefon numarasını güncel tutmakla
                          yükümlüdür.
                        </p>
                        <p>
                          <strong>9.8. Uygulanacak Hukuk ve Uyuşmazlıkların Çözümü.</strong> İşbu
                          Üyelik Sözleşmesi münhasıran Türkiye Cumhuriyeti kanunlarına tabi
                          olacaktır. İşbu Üyelik Sözleşmesi’nden kaynaklanan veya işbu Üyelik
                          Sözleşmesi ile bağlantılı olan her türlü ihtilaf, İstanbul Anadolu Merkez
                          Mahkemeleri ve İcra Müdürlükleri'nin münhasır yargı yetkisinde olacaktır.
                        </p>
                        <ol start="10">
                          <li>
                            <strong>YÜRÜRLÜK</strong>
                          </li>
                        </ol>
                        <p>
                          Kullanıcı Kayıt Formu'nu doldurup formun altında bulunan "Kabul Ediyorum"
                          butonunu tıkladığında bu Sözleşme Taraflar arasında süresiz olarak
                          yürürlüğe girer. Üye, işbu Sözleşme’de yer alan maddelerin tümünü
                          okuduğunu, anladığını, kabul ettiğini; kendisiyle ilgili verdiği
                          bilgilerin doğruluğunu onayladığını kabul, beyan ve taahhüt eder.
                        </p>
                      </content>
                    </content>
                  </b-tab-item>
                  <b-tab-item label="Bilgilendirme" style="height:400px;">
                    <content class="content" style="text-align: justify; text-justify: inter-word;">
                      <p>
                        <b>onlineicdenetim.com</b> sitesinde yer alan bilgi, analiz ve üretilen
                        raporlar Neta Denetim tarafından “genel ve makul seviyede” bilgilendirme
                        amacı ile hazırlanmıştır. Bu analiz ve tavsiyeler, alacağınız yönetim ve
                        denetim kararlarınızı destekleyecek en üst seviyede yeterli bilgiyi
                        içermeyebilir.
                      </p>
                      <p>
                        Burada yer alan analiz ve tavsiyeler mali durumunuz, yönetim yapınız ve risk
                        alma tercihleriniz ile birebir örtüşmeyebilir. Bu nedenle, sadece burada yer
                        alan bilgilere dayanarak yönetim kararı verilmesi beklentilerinize, kurum ve
                        operasyonlarınıza en uygun sonuçları doğurmayabilir.
                      </p>
                      <p>
                        Tamamen size, operasyonlarınıza ve risk iştahınıza uygun yönetim ve denetim
                        danışmanlığı hizmeti Neta Denetim ve müşterisi arasında imzalanacak
                        Danışmanlık hizmet sözleşmesi çerçevesinde ayrıca sunulmaktadır.
                      </p>
                    </content>
                  </b-tab-item>
                </b-tabs>
              </div>
              <div class="b-portlet-footer">
                <div class="b-button-container">
                  <button
                    class="button is-primary is-pulled-right"
                    @click="isTermsOfServiceModalActive = false"
                  >
                    {{ $t('button.ok') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </b-modal>
  </div>
</template>

<script>
import { SIGNUP } from '../../store/actions.type'
import ApiService from '../../_api/api.service'

export default {
  data() {
    return {
      user: {},
      jobs: [],
      cities: [],
      sectorData: [],
      sectorGroups: [],
      sectors: [],
      isSubmitted: false,
      isTermsOfServiceModalActive: false,
      readAgree: false,
      sectorGroupId: null,
      confirmPassword: null,
      companyToken: null,
      companyName: null
    }
  },
  mounted() {
    const { companyToken } = this.$route.query
    this.companyToken = companyToken
    if (companyToken) {
      ApiService.get(`/company/isvalid/${companyToken}`).then(company => {
        if (company.isValid) {
          this.companyName = company.name
          this.loadSelects()
        } else {
          this.$buefy.dialog.alert({
            title: this.$t('title.error'),
            message: this.$t('description.companySignUpTokenValidationError'),
            confirmText: this.$t('button.ok'),
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fas',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      })
    } else {
      this.loadSelects()
    }
  },
  methods: {
    onChangeSectorGroup(selectedid) {
      this.sectors = this.sectorData.filter(s => s.parentId === selectedid)
    },
    loadSelects() {
      ApiService.query('/select/jobs').then(data => {
        this.jobs = data
      })
      ApiService.query('/select/cities').then(data => {
        this.cities = data
      })
      ApiService.query('/select/sectors').then(data => {
        this.sectorData = data
        this.sectorGroups = data.filter(i => i.parentId == null)
      })
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$recaptcha('signup').then(token => {
            this.signup(token)
          })
        }
      })
    },
    signup(recaptchaToken) {
      const verifyUrl = `${window.location.origin}/${this.$t('routes.user')}/${this.$t(
        'routes.verifyEmail'
      )}`
      this.user.email = this.user.email.toLowerCase()
      this.$store
        .dispatch(SIGNUP, {
          user: this.user,
          verifyUrl,
          recaptchaToken,
          companyToken: this.companyToken
        })
        .then(() => {
          this.isSubmitted = true
        })
    }
  }
}
</script>
<style>
.b-portlet .tabs ul li a {
  text-decoration: none !important;
}
.b-portlet .tabs.is-toggle li.is-active a {
  color: white !important;
}
</style>
